// 暂存入tempStorage
export const SAVE_ITEM = 'SAVE_ITEM'
// 删除temStorge中的指定数据
export const DELETE_ITEM = 'DELETE_ITEM'
// 初始化tempStroage
export const INITIAL_STROAGE = 'INITIAL_STROAGE'
// 页面缓存
export const GET_CATCHE_COMPONENTS = 'GET_CATCHE_COMPONENTS'